import {array} from 'yup'

export const TakeFirstSchema = array().compact((_value, index) => index > 0)
